module.exports = __webpack_public_path__ + "img/mao-depoimentos.7d747985.png";